import { ShieldAlert } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function AccessDenied({ message = "You do not have permission to view this page." }) {
  const navigate = useNavigate();
  return (
    <div data-testid="access-denied" className="flex flex-col items-center justify-center text-center py-24">
      <div className="grid place-items-center h-16 w-16 rounded-2xl bg-rose-50 text-rose-500 mb-4">
        <ShieldAlert className="h-8 w-8" />
      </div>
      <h2 className="text-xl font-bold text-slate-900">Access restricted</h2>
      <p className="mt-2 text-sm text-slate-500 max-w-sm">{message}</p>
      <button onClick={() => navigate("/dashboard")} className="mt-6 h-11 px-5 rounded-lg bg-teal text-white font-semibold hover:bg-teal-700" data-testid="access-denied-home">
        Back to dashboard
      </button>
    </div>
  );
}
